import { useEffect, useState, type AnchorHTMLAttributes } from "react";

/** Minimal history router: no dependency, works with the PWA fallback. */
const listeners = new Set<() => void>();

function currentPath(): string {
  return location.pathname.replace(/\/+$/, "") || "/";
}

export function navigate(path: string, replace = false): void {
  if (currentPath() === path) return;
  if (replace) history.replaceState(null, "", path);
  else history.pushState(null, "", path);
  for (const l of listeners) l();
}

export function useRoute(): string {
  const [path, setPath] = useState(currentPath());
  useEffect(() => {
    const update = () => setPath(currentPath());
    listeners.add(update);
    window.addEventListener("popstate", update);
    return () => {
      listeners.delete(update);
      window.removeEventListener("popstate", update);
    };
  }, []);
  return path;
}

export function Link({ to, children, className = "", onClick, ...attributes }: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "onClick"> & { to: string; onClick?: () => void }) {
  return (
    <a
      {...attributes}
      href={to}
      className={className}
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        onClick?.();
        navigate(to);
      }}
    >
      {children}
    </a>
  );
}
